import { GoogleCourse, GoogleStudent } from '@/types/student';

function parseErrorResponse(response: Response): Promise<string> {
    return response
        .json()
        .then((data) => data.error?.message || `HTTP error! status: ${response.status}`)
        .catch(() => `HTTP error! status: ${response.status}`);
}

export async function fetchCourses(token: string, pageSize: number = 12, nextPageToken?: string): Promise<{ courses?: GoogleCourse[]; nextPageToken?: string }> {
    const response = await fetch(
        `https://classroom.googleapis.com/v1/courses?teacherId=me&courseStates=ACTIVE${pageSize ? `&pageSize=${pageSize}` : ''}${nextPageToken ? `&pageToken=${nextPageToken}` : ''}`,
        {
            headers: { Authorization: `Bearer ${token}` },
        },
    );

    if (!response.ok) throw new Error(await parseErrorResponse(response));

    const data: { courses?: GoogleCourse[]; nextPageToken?: string } = await response.json();

    return data;
}

export async function fetchStudents(token: string, courseId: string, pageSize?: number, nextPageToken?: string): Promise<{ students?: GoogleStudent[]; nextPageToken?: string }> {
    const response = await fetch(`https://classroom.googleapis.com/v1/courses/${courseId}/students${pageSize ? `&pageSize=${pageSize}` : ''}${nextPageToken ? `&pageToken=${nextPageToken}` : ''}`, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) throw new Error(await parseErrorResponse(response));

    const data: { students?: GoogleStudent[]; nextPageToken?: string } = await response.json();

    return data;
}
